import { render, staticRenderFns } from "./menuItemGroup.vue?vue&type=template&id=4b609efe&lang=pug"
import script from "./menuItemGroup.vue?vue&type=script&lang=coffee"
export * from "./menuItemGroup.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports